import {COMMUNITY} from '../../../endpoints'
import {apiPublic} from '../../../api'
import types from '../types/community'
import queryString from 'querystring'
import {endpoint as endpointText} from '../../../common/text'

export default class community {

  static setLimit(limit) {
    return {
      type: types.SET_LIMIT,
      payload: {
        limit,
      }
    }
  }

  static setOffset(offset) {
    return {
      type: types.SET_OFFSET,
      payload: {
        offset,
      }
    }
  }

  static searchMore() {
    return function(dispatch, getState) {

      const state = getState().ui.community.community

      const search = getState().ui.header.header.get('search')
      const limit = state.get('limit')
      const offset = state.get('offset')
      const category = state.get('category')

      dispatch({
        type: types.SEARCH_MORE,
      })

      const searchParams = {Limit: limit, Offset: offset, name: search}
      if (category !== 0) searchParams.category = category
      const params = queryString.stringify(searchParams)

      apiPublic.get(COMMUNITY + '/community/object?' + params)
        .then(response => {
          const data = response.data.description
          dispatch(community.searchMoreSuccess(data.communityObjects || [], data.quantity))
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(community.searchMoreFail(message))
        })
    }
  }

  static searchMoreSuccess(items, quantity) {
    return {
      type: types.SEARCH_MORE_SUCCESS,
      payload: {
        items,
        quantity,
      },
    }
  }

  static searchMoreFail(error) {
    return {
      type: types.SEARCH_MORE_FAIL,
      payload: {
        error,
      },
    }
  }

  static search() {
    return function(dispatch, getState) {

      const state = getState().ui.community.community

      const search = getState().ui.header.header.get('search')
      const limit = 8
      const offset = 0
      const category = state.get('category')

      const lastSearchID = (new Date()).getMilliseconds()
      dispatch({
        type: types.SEARCH,
        payload: {
          lastSearchID,
        },
      })

      const searchParams = {Limit: limit, Offset: offset, name: search}
      if (category !== 0) searchParams.category = category
      const params = queryString.stringify(searchParams)

      apiPublic.get(COMMUNITY + '/community/object?' + params)
        .then(response => {
          if (lastSearchID === getState().ui.community.community.get('lastSearchID')) {
            const data = response.data.description
            dispatch(community.searchSuccess(data.communityObjects || [], data.quantity))
          }
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(community.searchFail(message))
        })
    }
  }

  static searchSuccess(items, quantity) {
    return {
      type: types.SEARCH_SUCCESS,
      payload: {
        items,
        quantity,
      },
    }
  }

  static searchFail(error) {
    return {
      type: types.SEARCH_FAIL,
      payload: {
        error,
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/sections/community/actions/community.js